/** 環境変数名 */
export const ENV_KEYS = {
  /** 環境区分 */
  REACT_APP_ENV: 'REACT_APP_ENV',
  /** APIのURL */
  REACT_APP_API_URL: 'REACT_APP_API_URL',
  /** シークレットキー */
  REACT_APP_SECRET_KEY: 'REACT_APP_SECRET_KEY',
  /** 暗号キー */
  REACT_APP_CRYPTOGRAM: 'REACT_APP_CRYPTOGRAM',
  /** モジュール区分 */
  REACT_APP_MODULE: 'REACT_APP_MODULE',
  /** FBコールURL */
  REACT_APP_FB_CALL_URL: 'REACT_APP_FB_CALL_URL',
  SKIP_PREFLIGHT_CHECK: 'SKIP_PREFLIGHT_CHECK',
  /** ご案内書類：添付ファイル上限(デフォルト:17ファイル) */
  REACT_APP_ATTACHED_FILE_LIMIT: 'REACT_APP_ATTACHED_FILE_LIMIT',
  /** ご案内書類：画像サイズ横幅 */
  REACT_APP_PICTURE_SIZE_WIDTH: 'REACT_APP_PICTURE_SIZE_WIDTH',
  /** ご案内書類：画像サイズ縦幅 */
  REACT_APP_PICTURE_SIZE_HEIGHT: 'REACT_APP_PICTURE_SIZE_HEIGHT',
  /** メタタグ：viewport：デフォルト */
  REACT_APP_META_VIEWPORT: 'REACT_APP_META_VIEWPORT',
  /** メタタグ：viewport：ピンチ操作可能 */
  REACT_APP_META_VIEWPORT_USER_SCALABLE: 'REACT_APP_META_VIEWPORT_USER_SCALABLE',
  /** 料金シミュレータのURL */
  REACT_APP_SIMULATOR_URL: 'REACT_APP_SIMULATOR_URL',
  /** 料金シミュレータのReferrer */
  REACT_APP_SIMULATOR_REFERRER: 'REACT_APP_SIMULATOR_REFERRER',
  /** 外部システム起動をタブで確認 */
  REACT_APP_IS_CONFIRM_EXTERNAL_SYSTEM_BY_TAB: 'REACT_APP_IS_CONFIRM_EXTERNAL_SYSTEM_BY_TAB',
  /** オプトイン許諾メールの除外正規表現 */
  REACT_APP_OPTIN_URL_REGEX: 'REACT_APP_OPTIN_URL_REGEX',
  /** クルーナビURL */
  REACT_APP_CREW_NAVI_FQDN: 'REACT_APP_CREW_NAVI_FQDN',
  /** ヒアナビURL */
  REACT_APP_HEARNAVI_FQDN: 'REACT_APP_HEARNAVI_FQDN',
} as const;
/** 環境変数名 */
type EnvKeys = typeof ENV_KEYS[keyof typeof ENV_KEYS];

/** 実行環境 */
export const EXECUTION_ENVS = {
  DEBUG: 'debug',
  LOCAL: 'local',
  CICD: 'cicd',
  DEV: 'dev',
  ST1: 'st1',
  ST2: 'st2',
  ST3: 'st3',
  PRD: 'prd',
};
/** 実行環境 */
type ExecutionEnvs = typeof EXECUTION_ENVS[keyof typeof EXECUTION_ENVS];

/** モジュール区分 */
export const MODULES = {
  CREW: 'crew',
  AGENCY: 'agency',
  EMPLOYEE: 'employee',
  CUSTOMER: 'customer',
};
/** モジュール区分 */
type Modules = typeof MODULES[keyof typeof MODULES];

/**
 * 環境変数を返却
 * @param envKey 環境変数名
 * @returns
 */
export const getEnvValue = (envKey: EnvKeys): string => {
  return process.env[envKey] || '';
};

/**
 * 環境変数を返却(Boolean)
 * @param envKey 環境変数名
 * @returns
 */
export const getEnvValueBoolean = (envKey: EnvKeys): boolean => {
  const value = process.env[envKey];
  return value && value === 'true' ? true : false;
};

/**
 * 開発環境を判定
 * @param envs
 * @returns
 */
export const isExecutionEnv = (envs: ExecutionEnvs[]): boolean => {
  return envs.includes(getEnvValue(ENV_KEYS.REACT_APP_ENV));
};

/**
 * 開発環境(ローカル)かを判定
 * @param envs
 * @returns
 */
export const isExecutionEnvLocal = (envs = [EXECUTION_ENVS.DEBUG, EXECUTION_ENVS.LOCAL]): boolean => {
  return isExecutionEnv(envs);
};

/**
 * モジュールを判定
 * @param module
 * @returns
 */
export const isModule = (modules: Modules[]): boolean => {
  return modules.includes(getEnvValue(ENV_KEYS.REACT_APP_MODULE));
};

/**
 * クルーモジュールか判定
 * @returns
 */
export const isCrewModule = () => {
  return isModule([MODULES.CREW]);
};

/**
 * 代理店モジュールか判定
 * @returns
 */
export const isAgencyModule = () => {
  return isModule([MODULES.AGENCY]);
};

/**
 * 営業モジュールか判定
 * @returns
 */
export const isEmployeeModule = () => {
  return isModule([MODULES.EMPLOYEE]);
};

/**
 * 顧客モジュールか判定
 * @returns
 */
export const isCustomerModule = () => {
  return isModule([MODULES.CUSTOMER]);
};
